import React from "react";
import { Modal, Button, ButtonGroup, Text, Stack } from "@chaser/components";
import useModuleInfo from "../../../hooks/useModuleInfo";
import { addonIds, Modules, periodToNoticeTime } from "../../../util/constants";
import usePush from "../../../hooks/usePush";
import SubscriptionService from "../../../services/subscription-service";
import useShortCode from "../../../hooks/useShortCode";
import { pendo } from "../../../util/logging";

const AddonDowngradeModal = ({
  open,
  close,
  onClosed,
  onSuccess,
  addon: addOnProp,
  moduleName,
}) => {
  const shortCode = useShortCode();
  const isUsersAddon =
    addOnProp?.id === addonIds.USER ||
    addOnProp?.id === addonIds.ADDITIONAL_USERS;
  const isMultiModuleUsersRemoval =
    moduleName === Modules.ORGANISATION && isUsersAddon;

  const { plan, refetchSubscriptionData } = useModuleInfo(moduleName, {
    suspense: false,
  });

  const { execute, loading: isMutating } = usePush(
    SubscriptionService.removeAddOn,
    {
      errorToast: true,
      successToast: "Add-on removed successfully",
    },
  );

  async function removeAddOn(addonId, shortCode, moduleName) {
    const moduleNames = isMultiModuleUsersRemoval
      ? [Modules.ORGANISATION, Modules.RECEIVABLES]
      : moduleName
        ? [moduleName]
        : [];

    const [err] = await execute({
      shortCode,
      addonId,
      moduleName,
      moduleNames,
    });

    if (err) return;

    pendo.track("addon_removed", {
      addonId,
      addonName: addOnProp?.name,
      moduleName,
    });

    if (onSuccess) onSuccess(addonId);

    refetchSubscriptionData();

    close(true);
  }

  return (
    <Modal
      title={"Are you sure you want to remove this add-on?"}
      open={open}
      toggle={close}
      onClosed={onClosed}
    >
      <Modal.Body>
        <Stack gap="small" mt="small">
          <Text>
            {`You can remove add-ons at any time with ${
              periodToNoticeTime[plan?.period]
            } days notice ahead of your billing renewal date.`}
          </Text>
          <Text>
            You'll continue to have full access to this add-on until your
            renewal date.
          </Text>
        </Stack>
      </Modal.Body>
      <Modal.Footer>
        <ButtonGroup>
          <Button
            appearance="secondary"
            onClick={() => close(true)}
            data-trackingid="addon-cancel-downgrade"
          >
            Close
          </Button>
          <Button
            intent="danger"
            onClick={async () =>
              removeAddOn(addOnProp.id, shortCode, moduleName)
            }
            loading={isMutating}
            disabled={isMutating}
            data-trackingid="addon-confirm-remove"
          >
            Remove
          </Button>
        </ButtonGroup>
      </Modal.Footer>
    </Modal>
  );
};

export default AddonDowngradeModal;